import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { projectsApi } from '@/api/projects'
import type { ConnectPlaneProjectInput } from '@/types/project'

export const projectKeys = {
  all: ['projects'] as const,
  detail: (id: string) => ['projects', id] as const,
}

export function useProjects() {
  return useQuery({
    queryKey: projectKeys.all,
    queryFn: async () => {
      try {
        const data = await projectsApi.getAll()
        return Array.isArray(data) ? data : []
      } catch {
        return []
      }
    },
    staleTime: 30_000, // 30 seconds
  })
}

export function useProject(id: string) {
  return useQuery({
    queryKey: projectKeys.detail(id),
    queryFn: async () => {
      try {
        return await projectsApi.getById(id)
      } catch {
        return null
      }
    },
    enabled: !!id,
  })
}

export function useConnectPlaneProject() {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (data: ConnectPlaneProjectInput) => projectsApi.connectPlane(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: projectKeys.all })
    },
  })
}
